import { compose, withProps, branch, mapProps } from 'recompose';
import { List } from 'immutable';
import { connect } from 'react-redux';
import uniq from 'lodash/uniq';

import { bookingsByIds } from '../../../entities/Booking/selectors';
import withAgreement from '../../../containers/withAgreement';
import withWorkTypes from '../../../containers/withWorkTypes';

export default compose(
  connect((state, { timeplanUnits }) => {
    const bookingsIds = timeplanUnits
      .map(({ booking }) => booking)
      .filter(id => !!id);
    const bookings = bookingsByIds(state, bookingsIds);
    const customerAgreementsIds = uniq(bookings
      .map(({ customerAgreement }) => customerAgreement)
      .toJS(),
    );
    return {
      bookings,
      agreementsIds: customerAgreementsIds,
    };
  }),
  branch(({ agreementsIds }) => agreementsIds.length <= 1,
    compose(
      mapProps(({ agreementsIds, ...props }) => ({
        ...props,
        agreementId: agreementsIds[0],
      })),
      withAgreement,
      mapProps(({ agreement, ...props }) => ({
        ...props,
        workTypesIds: agreement ? agreement.get('workTypes') : [],
      })),
      withWorkTypes,
    ),
    withProps(({
      workTypes: new List(),
    })),
  ),
);
